import { render, staticRenderFns } from "./UserSearchResult.vue?vue&type=template&id=f978943a"
import script from "./UserSearchResult.vue?vue&type=script&lang=js"
export * from "./UserSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports